module.exports = __webpack_public_path__ + "img/Videos.30ee6e92.svg";